import React, { useState } from 'react';
import DaumPostcode from 'react-daum-postcode';
import Modal from 'react-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const InventoryModal = ({ isVisible, setVisible }: Props) => {
  const onCloseModal = () => {
    setVisible(false);
  };

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onCloseModal}
      className="guideModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}>
      <Style>
        <div className="modalWrapper">
          <div className="modalTitle">
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
              alt="close"
            />
            <div className="headerBar" />
            <h2>재고관리 사용법</h2>
          </div>
          <div className="modalContent">
            <div className="guide">
              <ul>
                <li>재고 무제한 사용하기</li>
              </ul>
              <div className="pointBox">
                <p>
                  처음상태에서 아무것도 변경하지 않는다면 (재고 관리 사용 여부 미체크시) 재고 무제한
                  사용상태입니다.
                </p>
              </div>
            </div>
            <div className="guide">
              <ul>
                <li>특정 시간에 재고 리셋해서 관리하기</li>
              </ul>
              <h3>
                1. 재고 관리 사용 여부 체크(꼭 체크하기!) <br />
                2. 일일 재고량 입력 <br />
                3. 일일 재고량 채워지는 시간 선택 (초기 설정값은 매장 오픈 시간입니다.) <br />
                4. 일일 재고량과 동일한 실재고량 입력 <br />
                5. 전체 저장하기 버튼 클릭
              </h3>
            </div>
            <div className="guide">
              <ul>
                <li>특정 시간 재고 리셋을 원하지 않고 재고 사용만하기</li>
              </ul>
              <h3>
                1. 재고 관리 사용 여부 체크(꼭 체크하기!) <br />
                2. 실재고량 입력 <br />
                3. 전체 저장하기 버튼 클릭 <br />
              </h3>
              <div className="pointBox">
                <h2>실재고량이란?</h2>
                <p>
                  공산품처럼 한번 입고된 수량이 판매량 만큼 감소되고 다시 입고전까지 채워지지 않는
                  수량입니다. 일일재고량과 실재고량이 같이 입력하면 금일만 실재고량이 적용되며,
                  일일재고량이 채워지는 시간을 기준으로 일일재고량이 적용됩니다. 매일 채워지는
                  상품이 오늘만 특별하게 수량이 다른 경우에 사용 할 수 있습니다.
                </p>
              </div>
            </div>
            <div className="guide">
              <ul>
                <li>특정 시간에 재고가 리셋되는데 오늘만 특수하게 재고를 다르게 하고 싶은 경우</li>
              </ul>
              <h3>
                1. 실재고량 수정 <br />
                2. 전체 저장하기 버튼 클릭
              </h3>
              <div className="pointBox">
                <h2>일일 재고량 채워지는 시간 설정 방법</h2>
                <p>
                  재고 관리 사용 여부 체크 시 일일 재고량 채워지는 시간이 자동으로 매장 오픈
                  시간으로 변경됩니다. 매장 오픈 시간은 매장관리에서 설정한 시간이며, 요일별로 매장
                  오픈 시간이 다른 경우 가장 빠른 시간으로 설정됩니다. 다른 시간에 재고가 채워지길
                  원한다면 직접 시간 선택도 가능합니다. 일일 재고량 채워지는 시간은 선택되어 있으나
                  일일 재고량의 값이 0인 경우에는 일일 재고량을 사용할 수 없으니 사용을 원하는 경우
                  일일 재고량에 재고량을 입력해 주세요.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default InventoryModal;

const Style = styled.div`
  li::marker {
    color: #4dd2ae;
  }

  .modalWrapper {
    padding: 10px;
    height: 80vh;
    overflow: auto;
    text-align: left;
  }
  .modalTitle {
    position: relative;
    .headerBar {
      width: 44px;
      height: 5px;
      margin: 0 auto;
      border-radius: 10px;
      background: #4dd2ae;
    }
    h2 {
      margin: 22px 0 52px 0;
      font-size: 24px;
      font-weight: 500;
      color: #555;
      text-align: center;
    }
  }

  /* modalContent */
  .guide {
    margin-bottom: 40px;
  }
  ul {
    padding: 0 0 0 20px;
  }
  li {
    font-size: 18px;
    font-weight: 500;
    color: #555;
  }
  h3 {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 500;
    color: #555;
  }
  .pointBox {
    padding: 6px 16px;
    background: #ecf5f3;
    border-radius: 10px;

    h2 {
      font-size: 16px;
      font-weight: 500;
      color: #40977f;
      line-height: 26px;
    }
    p {
      font-size: 16px;
      font-weight: 500;
      color: #979797;
      line-height: 26px;
    }
  }
`;
